package com.bikompanion.ui.strings

val TrBikompanionStrings = object : BikompanionStrings {
    override val actionRetry = "Tekrar dene"
    override val actionClose = "Kapat"
    override val actionSubmit = "Gönder"
    override val detailsLabel = "Ayrıntılar"
    override val detailsShow = "Ayrıntıları göster"
    override val detailsHide = "Ayrıntıları gizle"
    override val actionGetDirections = "Yol tarifi al"
    override val actionShareStation = "İstasyonu paylaş"
    override val linkCopied = "Bağlantı kopyalandı"
    override val locateShow = "Konumumu göster"
    override val locateFollowHeading = "Yönümü takip et"
    override val locateStopFollowing = "Beni takip etmeyi bırak"
    override val settingsTitle = "Ayarlar"
    override val actionBack = "Geri"
    override val settingsAppearance = "Görünüm"
    override val settingsLanguage = "Dil"
    override val languageSystem = "Sistem varsayılanı"
    override val themeSystem = "Sistem"
    override val themeLight = "Açık"
    override val themeDark = "Koyu"
    override val settingsNotifications = "Bildirimler"
    override val stationAlerts = "İstasyon uyarıları"
    override val notificationsOn = "Açık: İzlenen bir istasyonda bisiklet olduğunda haber veririz"
    override val notificationsOff = "Kapalı: İzlenen istasyonlar sizi uyaramaz"
    override val notificationsBlocked = "Engellendi: Tarayıcınızın site ayarlarından bildirimlere izin verin"
    override val actionManage = "Yönet"
    override val actionTurnOn = "Aç"
    override val settingsSupport = "Destek"
    override val sendFeedback = "Geri bildirim gönder"
    override val sendFeedbackDescription = "Bir sorunu veya yanlış istasyon verisini bize bildirin"
    override val shareApp = "Uygulamayı paylaş"
    override val settingsAbout = "Hakkında"
    override val aboutApp = "Bikompanion hakkında"
    override val aboutDevelopedBy = "Geliştiren: Tiago Araujo"
    override val aboutDataSources = "Veri kaynakları"
    override val sourceCityBikesDescription = "Dünya genelindeki bisiklet paylaşım ağları"
    override val sourceGbfsTitle = "Operatörlerin GBFS akışları"
    override val sourceGbfsDescription = "Bisiklet paylaşım operatörlerinden canlı istasyon verileri"
    override val sourceOsmTitle = "OpenStreetMap katkıda bulunanları"
    override val sourceOsmDescription = "Bisiklet parkı ve harita verileri"
    override val sourceCartoDescription = "Harita parçaları"
    override val aboutLegal = "Yasal"
    override val licensesTitle = "Açık kaynak lisansları"
    override val privacyPolicy = "Gizlilik politikası"
    override val deleteRatings = "Değerlendirmelerimi sil"
    override val deleteRatingsDescription = "Silebilmemiz için anonim kimliğinizi bize e-postayla gönderir"
    override val licensesLoadFailed = "Lisans listesi yüklenemedi"
    override val aboutVersion = { version: String -> "Sürüm $version" }
    override val issueFlatTire = "Lastik patlak"
    override val issueFrontBrake = "Ön fren çalışmıyor"
    override val issueRearBrake = "Arka fren çalışmıyor"
    override val issueChain = "Zincir kayıyor"
    override val issueGears = "Vitesler geçmiyor"
    override val issueSeat = "Sele hasarlı veya yok"
    override val issueLights = "Işıklar çalışmıyor"
    override val issueLockOrBasket = "Kilit veya sepet hasarlı"
    override val issueFrame = "Kadro hasarlı"
    override val issueMotor = "Elektrik motoru çalışmıyor"
    override val issueBattery = "Batarya şarj olmuyor"
    override val issueOther = "Diğer"
    override val networksLoadFailed = "Bisiklet ağları yüklenemedi. Bağlantınızı kontrol edin."
    override val parkingLoadFailed = "Bisiklet parkları yüklenemedi"
    override val parkingLoading = "Bisiklet parkı aranıyor…"
    override val stationsLoading = "Bisiklet istasyonları yükleniyor…"
    override val noNetworkHereTitle = "Burada bisiklet paylaşımı yok"
    override val noNetworkHereHint = "En yakın ağı bulmak için uzaklaştırın"
    override val installTitle = "Bikompanion'u yükleyin"
    override val installHintIos = "Paylaş'a, ardından Ana Ekrana Ekle'ye dokunun."
    override val installHintAndroid = "Uygulamayı Google Play'den edinin."
    override val actionInstall = "Yükle"
    override val parkingTypeStands = "Bisiklet parkı"
    override val parkingTypeShed = "Bisiklet barınağı"
    override val parkingTypeLockers = "Bisiklet dolapları"
    override val parkingTypeBuilding = "Bisiklet binası"
    override val parkingTypeOther = "Bisiklet parkı"
    override val fieldAddress = "Adres"
    override val fieldCovered = "Kapalı"
    override val fieldYes = "Evet"
    override val fieldNo = "Hayır"
    override val fieldId = "ID"
    override val fieldStationId = "İstasyon kimliği"
    override val fieldCoordinates = "Koordinatlar"
    override val fieldCapacity = "Kapasite"
    override val fieldNetwork = "Ağ"
    override val fieldName = "Ad"
    override val fieldCity = "Şehir"
    override val fieldCountry = "Ülke"
    override val fieldCompany = "Şirket"
    override val fieldLicense = "Lisans"
    override val fieldLicenseUrl = "Lisans URL'si"
    override val availabilityBikes = "Bisiklet"
    override val availabilityElectric = "Elektrikli"
    override val availabilityEmpty = "Boş"
    override val bicingNextPickup = { p0: String -> "Sonraki Bicing alımı: $p0" }
    override val rateTitle = "Bisikleti kontrol et veya puanla"
    override val rateFindingNetworks = "Çevrenizdeki bisiklet ağları aranıyor…"
    override val rateWhatsWrong = "Sorunu nedir?"
    override val rateBikeNumber = "Bisiklet numarası"
    override val rateElectricBike = "Elektrikli bisiklet"
    override val rateVoteBad = "Kötü"
    override val rateVoteGood = "İyi"
    override val rateWhichNetwork = "Bu bisiklet hangi ağa ait?"
    override val refreshRateLimited = "İstek sınırına ulaşıldı — otomatik olarak yeniden deneniyor"
    override val refreshFailed = "Güncellenemedi"
    override val refreshNextUpdate = { p0: Int -> "Sonraki güncelleme: $p0 sn" }
    override val refreshUpdating = "Güncelleniyor…"
    override val dataNone = "Henüz veri yok"
    override val dataAgeJustNow = "Az önceki veriler gösteriliyor"
    override val dataAgeMinutes = { p0: Int -> "$p0 dk önceki veriler gösteriliyor" }
    override val dataAgeHours = { p0: Int -> "$p0 sa önceki veriler gösteriliyor" }
    override val dataAgeDays = { p0: Int -> "$p0 gün önceki veriler gösteriliyor" }
    override val actionOpenOperator = { p0: String -> "$p0 uygulamasını aç" }
    override val watchNormal = "Normal bisikletleri izle"
    override val watchElectric = "Elektrikli bisikletleri izle"
    override val watchInstallNormal = "Normal bisikletleri izlemek için uygulamayı yükleyin"
    override val watchInstallElectric = "Elektrikli bisikletleri izlemek için uygulamayı yükleyin"
    override val watchStopNormal = "Normal bisikletleri izlemeyi durdur"
    override val watchStopElectric = "Elektrikli bisikletleri izlemeyi durdur"
    override val actionCheckRateBike = "Kontrol et / Puanla"
    override val layerStations = "İstasyonlar"
    override val layerParking = "Bisiklet parkı"
    override val mapLabelBikes = { p0: Int -> "$p0 bisiklet" }
    override val mapLabelEbikes = { p0: Int -> "$p0 elektrikli" }
    override val mapLabelFree = { p0: Int -> "$p0 boş" }
    override val scoreHeadline = { p0: String, p1: String -> "Bisiklet $p0 · $p1" }
    override val scoreNoRatings = "Henüz puan yok — ilk puanı siz verin."
    override val scoreLooksGood = "İyi görünüyor."
    override val scoreHasProblems = "Bu bisikletle sorun yaşanmış."
    override val scoreMixed = "Karışık yorumlar."
    override val ratingNetworkRequired = "Önce bu bisikletin ağını seçin."
    override val ratingThanks = { p0: String -> "$p0 numaralı bisikleti puanladığınız için teşekkürler!" }
    override val ratingCooldown = { p0: Int -> "Bu bisikleti kısa süre önce puanladınız. $p0 dk sonra tekrar deneyin." }
    override val ratingQueued = "Kaydedildi — yeniden çevrimiçi olduğunuzda göndereceğiz."
    override val ratingInvalidBike = "Bu bisiklet numarası bu ağ için geçerli değil."
    override val ratingRejected = "Puan kaydedilemedi. Lütfen daha sonra tekrar deneyin."
    override val notificationFoundTitle = "Bisiklet müsait"
    override val notificationFoundNormal = { p0: String -> "$p0 istasyonunda normal bisiklet müsait" }
    override val notificationFoundElectric = { p0: String -> "$p0 istasyonunda elektrikli bisiklet müsait" }
    override val notificationExpiredTitle = "İstasyon izleme sona erdi"
    override val notificationExpiredNormal = { p0: String -> "$p0 istasyonunda normal bisiklet izleme 30 dakika sonra durduruldu" }
    override val notificationExpiredElectric = { p0: String -> "$p0 istasyonunda elektrikli bisiklet izleme 30 dakika sonra durduruldu" }
    override val channelWatchAlertsName = "İstasyon izleme uyarıları"
    override val channelWatchAlertsDescription = "Bisiklet durumu ve istasyon izleme güncellemeleri"
    override val channelBackgroundWatchName = "Arka planda istasyon izleme"
    override val notificationWatchingTitle = "Bisiklet istasyonları izleniyor"
    override val notificationWatchingText = "Seçilen istasyonlar arka planda izleniyor"
    override val scoreFewRatings = { count: Int -> "Şimdiye kadar yalnızca $count puan." }
    override val scorePositiveRides = { percent: Int, count: Int -> "Son $count sürüşte %$percent olumlu" }
}
